import React from "react";
import UserGreenIcon from "../Common/svg/usergreenicon";
import PhoneIcon from "../Common/svg/phoneicon";
import LocationSvg from "../Common/svg/locationGray";
import { useNavigate } from "react-router-dom";

const CurioerInfo = ({ orderData }) => {
  const navigate = useNavigate();

  const order = orderData?.data?.order;
  const courier = order?.courier;

  if (!order || !courier) {
    return (
      <div className="col-md-4 pe-0">
        <div className="card rounded-4 shadow-sm">
          <div className="card-body">
            <div className="d-flex align-items-center gap-2 mb-3">
              <UserGreenIcon />
              <h5 className="text-smoke font16 font700">معلومات المندوب</h5>
            </div>
            <div className="text-center text-muted py-3">
              لا توجد بيانات مندوب متاحة
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="col-md-4 pe-0">
      <div className="card rounded-4 shadow-sm">
        <div className="card-body">
          <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center gap-2">
              {" "}
              <UserGreenIcon />
              <h5 className="text-smoke font16 font700">معلومات المندوب</h5>
            </div>
            <button
              data-tooltip-id="show"
              className="btn btn-primary p-1"
              onClick={() =>
                navigate(`${process.env.PUBLIC_URL}/curior/${courier.id}`)
              }
            >
              المزيد
            </button>
          </div>

          <ul className="d-flex flex-column gap-2 mt-2">
            <div>
              <h6 className="text-gray">الإسم</h6>
              <h6 className="text-smoke">{courier.name || "غير محدد"}</h6>
            </div>

            <li className="d-flex align-items-center gap-1">
              <PhoneIcon />
              <span className="text-smoke">{courier.phone || "غير محدد"}</span>
            </li>

            {courier.id && (
              <li className="d-flex align-items-center gap-1">
                <span className="text-gray">رقم المندوب:</span>
                <span className="text-smoke">{courier.id}</span>
              </li>
            )}

            {courier.unread_messages_count !== undefined && (
              <li className="d-flex align-items-center gap-1">
                <span className="text-gray">الرسائل غير المقروءة:</span>
                <span className="text-smoke">
                  {courier.unread_messages_count}
                </span>
              </li>
            )}

            {courier.lat && courier.lng && (
              <li className="d-flex align-items-center gap-1">
                <LocationSvg />
                <span className="text-smoke">
                  {courier.lat}, {courier.lng}
                </span>
              </li>
            )}

            {courier.email && (
              <li className="d-flex align-items-center gap-1">
                <span className="text-gray">البريد الإلكتروني:</span>
                <span className="text-smoke">{courier.email}</span>
              </li>
            )}

            {courier.status && (
              <li className="d-flex align-items-center gap-1">
                <span className="text-gray">الحالة:</span>
                <span className="text-smoke">{courier.status}</span>
              </li>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default CurioerInfo;
